import { render, staticRenderFns } from "./HonjoLogo.vue?vue&type=template&id=023cab33"
import script from "./HonjoLogo.vue?vue&type=script&lang=ts"
export * from "./HonjoLogo.vue?vue&type=script&lang=ts"
import style0 from "./HonjoLogo.vue?vue&type=style&index=0&id=023cab33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports